import Blockly from "blockly";
import Schema from "../schema";

export const menu = {
    name: (<div className="text"><u>H</u>ealth</div>),
    trigger: 'i',
    children: {
        'player_heal': {
            name: (<div className="text"><u>H</u>eal</div>),
            trigger: 'a',
        },
        'player_heart': {
            name: (<div className="text"><u>M</u>odify Hearts</div>),
            trigger: 'm',
        },
    }
}

/* ****************************************************************************************************************
 * Heal
 *
 * Heals the player using default heal logic.
 ******************************************************************************************************************/
Blockly.Blocks['player_heal'] = {
    init: function () {
        this.appendDummyInput('Input')
            .appendField('Heal the player')
        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setColour('#606060');
        this.setTooltip('Fully heals the currently playing character.')
    }
}

Blockly.JSON['player_heal'] = (block) => {
    return {
        action: 'player_heal'
    }
}

Schema.registerAction('player_heal', {
    "if": {
        "properties": {
            "action": {
                "const": "player_heal"
            }
        }
    },
    "then": {
        "properties": {
            "params": {
                "properties": {},
                "additionalProperties": false
            }
        }
    }
});

/* ****************************************************************************************************************
 * Modify Stats
 ******************************************************************************************************************/
Blockly.Blocks['player_heart'] = {
    init: function () {
        this.appendDummyInput('stat')
            .appendField('Modify')
            .appendField(
                new Blockly.FieldDropdown([
                    ['Black Hearts', 'black'],
                    ['Bone Hearts', 'bone'],
                    ['Broken Hearts', 'broken'],
                    ['Eternal Hearts', 'eternal'],
                    ['Golden Hearts', 'golden'],
                    ['Red Hearts', 'red'],
                    ['Red Heart Containers', 'container'],
                    ['Rotten Hearts', 'rotten'],
                    ['Soul Hearts', 'soul'],
                ]),
                'Heart'
            )
            .appendField('by')
            .appendField(
                new Blockly.FieldDropdown([
                    ['adding', 'add'],
                    ['removing', 'remove'],
                ]),
                'Modifier'
            )
            .appendField('by')
            .appendField(
                new Blockly.FieldTextInput(
                    '1',
                    this.validateStat
                ),
                'Value'
            );
        this.setInputsInline(false);
        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setColour('#606060');
        this.setTooltip('Modify the hearts of the player by the selected heart types.');
        this.setHelpUrl('');
    },
    validateStat: function (value) {
        let num = parseFloat(value);
        if (!num) return null;
        if (num < 0) return null;
        if (num > 50) return null;
    }
};

Blockly.JSON['player_heart'] = (block) => {
    let heart = block.getFieldValue('Heart');
    let modifier = block.getFieldValue('Modifier');
    let value = block.getFieldValue('Value');

    return {
        action: 'player_heart',
        params: {
            heart,
            modifier,
            value: parseInt(value, 10),
        }
    };
};

Schema.registerAction('player_heart', {
    "if": {
        "properties": {
            "action": {
                "const": "player_heart"
            }
        }
    },
    "then": {
        "properties": {
            "params": {
                "properties": {
                    "heart": {
                        "enum": [
                            'black',
                            'bone',
                            'broken',
                            'eternal',
                            'golden',
                            'red',
                            'container',
                            'rotten',
                            'soul',
                        ]
                    },
                    "modifier": {
                        "enum": [
                            "add",
                            "remove",
                        ],
                    },
                    "value": {
                        "type": "number",
                    },
                },
                "required": [
                    "heart",
                    "value",
                ],
                "additionalProperties": false
            }
        },
        "required": [
            "params"
        ]
    }
});